// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserSchema } from './v1/userSchema';

export const searchUsersPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const searchUsersQueryParamsSchema = z.object({
  q: z.coerce.string().describe("Search query"),
  per_page: z.optional(z.number().int().describe("Results per page")),
  page: z.optional(z.number().int().describe("Page number")),
});

export const searchUsersHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description search results
 */
export const searchUsers200Schema = z.array(z.lazy(() => v1UserSchema));

export const searchUsersQueryResponseSchema = z.lazy(() => searchUsers200Schema);
